import { FC, ReactNode } from 'react';
import { Box, Breadcrumbs, Typography } from '@mui/material';

import RightArrowIcon from '@mui/icons-material/ChevronRightRounded';

import FileManagementList from './file-management-list';
import RouteLink from 'shared/components/widgets/route-link';

type FileManagementProps = {
  title: string;
  isDialog?: boolean;
  linkStack?: any[];
  Filter: ReactNode;
  isCreateAction: boolean;
  createActionPath?: string;
  type?: any;
  listData?: any;
  getFilteredList?: (data: any) => void;
  handlePagination?: (data: any) => void;
  isLoading?: boolean

  // add handle detail dialog
  // 파일 상세 디테일창 띄우기
  handleOpenFileDetailDialog?: () => void;  // 매개변수 없이 실행되는 함수
  handleCloseFileDetailDialog?: () => void;  // 매개변수 없이 실행되는 함수

  setReload?: (reload: boolean) => void;
};

const FileManagement: FC<FileManagementProps> = ({
  title,
  isDialog = true,
  isLoading,
  linkStack,
  Filter,
  type,
  listData,
  getFilteredList,
  handlePagination,
  setReload,
}) => {

  return (
    <Box display="flex" flexDirection="column" flex={1}>
      <Box marginBottom="10px">
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<RightArrowIcon sx={{ color: 'var(--neutral-800)' }} />}
        >
          {linkStack?.map(({ label, path }, index) => {
            return (
              <RouteLink key={index} isActive={label === title} to={path}>
                {label}
              </RouteLink>
            );
          })}
        </Breadcrumbs>
      </Box>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom="20px"
      >
        <Typography variant="h6" color="var(--base-black)">
          {title}
        </Typography>
      </Box>
      {Filter}
      <FileManagementList
        type={type}
        isLoading={isLoading}
        listData={listData}
        isDetailOpen={isDialog}
        getFilteredList={getFilteredList}
        handlePagination={handlePagination}
        setReload={setReload}
      />
    </Box>
  );
};

export default FileManagement;
